import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { useParams } from "react-router-dom";

interface Arrivals {
  interval: string;
  qtd: number;
  delayed: number;
  on_time: number;
  in_transit: number;
}

export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);

  const [inTransit, setInTransit] = useState<number[]>([]);
  const [onTime, setOnTime] = useState<number[]>([]);
  const [delayed, setDelayed] = useState<number[]>([]);
  const [categories, setCategories] = useState<number[]>([]);
  const [qtd, setQtd] = useState<number[]>([]);
  const [indexTime, setIndexTime] = useState<number>(new Date().getHours());
  const [realTime, setIRealTime] = useState<string>("");
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  useEffect(() => {
    const time = new Date();
    setIndexTime(time.getHours());
    setIRealTime(time.getHours() + ":" + time.getMinutes());
    setDelayed(
      data.arrivals.map(function (route: Arrivals) {
        return route.delayed;
      })
    );
    setInTransit(
      data.arrivals.map(function (route: Arrivals) {
        return route.in_transit;
      })
    );
    setOnTime(
      data.arrivals.map(function (route: Arrivals) {
        return route.on_time;
      })
    );
    setCategories(
      data.arrivals.map(function (route: Arrivals) {
        return parseInt(route.interval);
      })
    );
    setQtd(
      data.arrivals.map(function (route: Arrivals) {
        return route.qtd;
      })
    );
  }, [data]);

  useEffect(() => {
    if (qtd.length !== 0) {
      setTotal(
        qtd.reduce(function (soma: number, i: number) {
          return soma + i;
        })
      );
    }
  }, [qtd]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          const selectedInterval = data.arrivals[config.dataPointIndex].interval;
          const type = config.seriesIndex;
          let status;

          switch (type) {
            case 0:
              status = 'Atrasadas';
              break;
            
            case 1:
              status = 'Em tempo';
              break;

            case 2:
              status = 'Em trânsito';
              break;

            default:
              break;
          }

          if (
            mode === "view" &&
            componentProperty({
              id: "chartArrivals",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartArrivals", {
                redirectTowerToAnalytics: true,
                date: true,
                arrivalGoalRoute: status,
                routeArrivalGoal: selectedInterval
              }),
              "_blank"
            );
          }
        },
      },
    },
    colors: ["#D35747", "#01b8aa", "#B1BCBE"],
    responsive: [
      {
        breakpoint: 480,
      },
    ],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        barHeight: "100%",
        horizontal: false,
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        rotate: -90,
      },
    },
    yaxis: {
      max: Math.max(...qtd),
      show: true,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
    annotations: {
      xaxis: [
        {
          x: categories[indexTime],
          borderColor: "#FFA510",
          label: {
            borderColor: "#FFA510",
            style: {
              fontSize: "12px",
              color: "#fff",
              background: "#FFA510",
              fontWeight: "bold",
            },
            orientation: "vertical",
            offsetY: 7,
            text: realTime,
          },
        },
      ],
    },
  };

  const series = [
    {
      name: "Atrasado",
      data: delayed,
    },
    {
      name: "No horário",
      data: onTime,
    },
    {
      name: "Em trânsito",
      data: inTransit,
    },
  ];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-arrivals" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-arrivals", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Chegadas: ${total} chegadas previstas para hoje`}
        clickable={componentProperty({
          id: "chartArrivals",
          property: "redirect",
        })}
        id="chart-arrivals"
      />
      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
